import styled, { css, type DefaultTheme, keyframes } from 'styled-components'
import { ErrorMessage } from '@velasca/ui/error-message'

const blinkAnimation = ({ theme }: { theme: DefaultTheme }) => keyframes`
  50% {
    background-color: ${theme.colors.primaryLight}40;
  }
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`

export const WrapperSizePicker = styled.div<{ isBlinking: boolean }>`
  gap: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 0 1.5rem;

  ${({ isBlinking }) =>
    isBlinking &&
    css`
      animation: ${blinkAnimation} 0.5s ease-in 0.7s;
    `}

  @media (min-width: 992px) {
    border-radius: 0.8rem;
    padding: 0;
  }
`

export const WrapText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
`

export const SizeGuideButton = styled.div`
  cursor: pointer;
`

export const AddToCart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;

  button {
    padding: 1.4rem 0.5rem;
  }
`

export const AddToCartButtonWrapper = styled.div`
  margin-top: 1rem;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (min-width: 992px) {
    gap: 1.5rem;
  }
`

export const StyledErrorMessage = styled(ErrorMessage)`
  margin: 1rem auto;
  text-align: center;
`
